import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e35fa96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "infographics-image-editor" }
const _hoisted_2 = { class: "infographics-image-editor__content" }
const _hoisted_3 = { class: "infographics-image-editor__buttons" }

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

import i18n from '@/plugins/i18n';

import {
  // appendNode,
  createDefaultImageWriter,
  createMarkupEditorShapeStyleControls,
  createMarkupEditorToolStyle,
  createMarkupEditorToolStyles,
  createMarkupEditorToolbar,
  // createNode,
  getEditorDefaults,
} from '@pqina/pintura';
import { PinturaEditor } from '@pqina/vue-pintura';
// import { useI18n } from 'vue-i18n';
import { cloneDeep } from 'lodash';

// import { removeBase64Prefix } from '@/helpers/removeBase64Prefix';
import { useServicesStore } from '@/store/services/index';

import { utils } from '@/data/pintura/utils';
import { IInfographicsImageData } from '@/types/IInfographicsImageData';

import localeRu from '@/assets/pintura/ru.json';
import localeEn from '@/assets/pintura/en.json';
import localeEs from '@/assets/pintura/es.json';
import localeAr from '@/assets/pintura/ar.json';
import localeKr from '@/assets/pintura/kr.json';

import AiButton from '@/components/UI/AiButton/AiButton.vue';

import AddImage from '@/components/common/AddImage/AddImage.vue';
import ResultImage from '@/components/common/ResultImage/ResultImage.vue';
import { useCommonStore } from '@/store/common';

// const { t } = useI18n();


export default /*#__PURE__*/_defineComponent({
  __name: 'Infographics',
  setup(__props) {

const { imageForActions, imageResult } = storeToRefs(useServicesStore());
const { isMobile } = storeToRefs(useCommonStore());

const editorProps = ref(
  getEditorDefaults({
    imageWriter: createDefaultImageWriter({
      targetSize: {
        width: 512,
        height: 512,
        fit: 'contain',
        upscale: false,
      },
    }),
  }),
);
const image = ref<IInfographicsImageData | null>(null);
const pinturaEditorRef = ref<any | null>(null);
const pinturaData = ref<any>();
// const fileUploadRef = ref<any | null>(null);
const appStickers = ref<any>([]);

const allStickers = computed(() => {
  const result = [...appStickers.value];
  return result;
});

const lang = computed(() => i18n.global.locale.value);

const pinturaLocale = computed(() => {
  let result = localeEn;
  if (lang.value === 'ar') {
    result = localeAr;
  } else if (lang.value === 'es') {
    result = localeEs;
  } else if (lang.value === 'kr') {
    result = localeKr;
  } else if (lang.value === 'ru') {
    result = localeRu;
  }
  return result;
});

const markupEditorToolbar = createMarkupEditorToolbar([
  'view',
  'text',
  'sharpie',
  'eraser',
  'path',
  'line',
  'arrow',
  'rectangle',
  'ellipse',
]);

const handleEditorProcess = async (imageState: any): Promise<void> => {
  pinturaData.value = imageState.detail;
  await fileToDataURL(imageState.detail.dest);
  // const imageData = await fileToDataURL(imageState.detail.dest);
  // const data = {
  //   state: imageState.detail.imageState,
  //   image: removeBase64Prefix(imageData),
  // };
};

const fileToDataURL = (file: any): any => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

const downloadFileHandler = (): any => {
  pinturaEditorRef.value.editor.processImage().then(async (res: any) => {
    const canvas = document.createElement('canvas');
    const img = new Image();
    img.onload = async () => {
      const imageWidth = img.width;
      const imageHeight = img.height;
      if (imageWidth / imageHeight > 1) {
        canvas.width = 512;
        canvas.height = (512 * imageHeight) / imageWidth;
      } else {
        canvas.height = 512;
        canvas.width = (512 * imageWidth) / imageHeight;
      }

      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const enlargedBase64src = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = enlargedBase64src;
        link.download = res.dest.name;

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          URL.revokeObjectURL(link.href);
          link?.parentNode?.removeChild(link);
        }, 0);
      }
    };
    const url = await fileToDataURL(res.dest);
    img.src = url;
  });
};

const willRenderShapeControls = (controls: any, selectedShapeId: string): any => {
  const [group1, group2] = controls;
  let buttons = [];
  if (group2) {
    // eslint-disable-next-line prefer-destructuring
    buttons = group2[3];
    // const [element, id, props, buttons] = group2;
  } else {
    // eslint-disable-next-line prefer-destructuring
    buttons = group1[3];
  }
  const selectedShapeIndex = pinturaEditorRef.value.editor.imageDecoration.findIndex(
    (shape: any) => shape.id === selectedShapeId,
  );

  buttons.unshift([
    'Button',
    'move-to-back',
    {
      hideLabel: true,
      label: 'Move to back',
      class: 'MoveToBackIcon',
      disabled: selectedShapeIndex === 0,
      icon:
        '<rect fill="currentColor" x="11" y="13" width="8" height="2" rx="1"></rect><rect fill="currentColor" x="9" y="17" width="10" height="2" rx="1"></rect><path d="M11.364 8H10a5 5 0 000 10M12 6.5L14.5 8 12 9.5z" stroke="currentColor" stroke-width=".125em" stroke-linecap="round"></path>',
      onclick: () => {
        const selectedShape = pinturaEditorRef.value.editor.imageDecoration.find(
          (shape: any) => shape.id === selectedShapeId,
        );
        pinturaEditorRef.value.editor.imageDecoration = [
          selectedShape,
          ...pinturaEditorRef.value.editor.imageDecoration.filter((shape: any) => shape.id !== selectedShapeId),
        ];
      },
    },
  ]);

  return controls;
};

const markupEditorShapeStyleControls = ref(
  createMarkupEditorShapeStyleControls({
    fontFamilyOptions: [
      //   // Add our custom option
      ['Alumni Sans', 'Alumni Sans'],
      ['Bad Script', 'Bad Script'],
      ['Balsamiq Sans', 'Balsamiq Sans'],
      ['Barlow', 'Barlow'],
      ['Caveat', 'Caveat'],
      ['Comfortaa', 'Comfortaa'],
      ['Comforter Brush', 'Comforter Brush'],
      ['Days One', 'Days One'],
      ['Dela Gothic One', 'Dela Gothic One'],
      ['El Messiri', 'El Messiri'],
      ['Geologica', 'Geologica'],
      ['JetBrains Mono', 'JetBrains Mono'],
      ['Josefin Sans', 'Josefin Sans'],
      ['Jura', 'Jura'],
      ['Kablammo', 'Kablammo'],
      ['Kanit', 'Kanit'],
      ['Kelly Slab', 'Kelly Slab'],
      ['Lobster', 'Lobster'],
      ['Lora', 'Lora'],
      ['Marmelad', 'Marmelad'],
      ['Montserrat Alternates', 'Montserrat Alternates'],
      ['Neucha', 'Neucha'],
      ['Noto Serif Display', 'Noto Serif Display'],
      ['Oswald', 'Oswald'],
      ['Overpass Mono', 'Overpass Mono'],
      ['Pacifico', 'Pacifico'],
      ['Pangolin', 'Pangolin'],
      ['Pattaya', 'Pattaya'],
      ['Play', 'Play'],
      ['Playfair', 'Playfair'],
      ['Playfair Display', 'Playfair Display'],
      ['Playfair Display SC', 'Playfair Display SC'],
      ['Podkova', 'Podkova'],
      ['Poiret One', 'Poiret One'],
      ['Prata', 'Prata'],
      ['PT Sans Narrow', 'PT Sans Narrow'],
      ['Raleway', 'Raleway'],
      ['Roboto Slab', 'Roboto Slab'],
      ['Rubik Mono One', 'Rubik Mono One'],
      ['Rubik Moonrocks', 'Rubik Moonrocks'],
      ['Russo One', 'Russo One'],
      ['STIX Two Text', 'STIX Two Text'],
      ['Tektur', 'Tektur'],
      ['Unbounded', 'Unbounded'],
      ['Yanone Kaffeesatz', 'Yanone Kaffeesatz'],
      ['Yeseva One', 'Yeseva One'],
      ['Ysabeau SC', 'Ysabeau SC'],
      // ...createDefaultFontFamilyOptions(),
    ],
  }),
);

// const willRenderShapePresetToolbar = (nodes: any): any => {
//   const addStickerButton = createNode('Button', 'AddStickerButton', {
//     label: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9276 2.39992C11.5206 2.3974 11.1914 2.73725 11.1922 3.15899L11.2071 10.9394L3.7666 10.9697C3.34486 10.9715 3.00164 11.3147 3.00001 11.7365C2.99837 12.1582 3.33893 12.4987 3.76067 12.497L11.2101 12.4666L11.225 20.2294C11.2258 20.6512 11.5563 20.9951 11.9633 20.9976C12.3702 21.0002 12.6995 20.6603 12.6986 20.2386L12.6837 12.4606L20.1785 12.43C20.6002 12.4283 20.9434 12.085 20.9451 11.6633C20.9467 11.2416 20.6062 10.9011 20.1844 10.9028L12.6808 10.9334L12.6658 3.16811C12.665 2.74637 12.3345 2.40244 11.9276 2.39992Z" fill="currentColor"/></svg> ${t(
//       'infographics.add-sticker',
//     )}`,
//     class: 'AddStickerButton',
//     onclick: () => {
//       if (fileUploadRef.value) {
//         fileUploadRef.value.click();
//       }
//     },
//   });

//   appendNode(addStickerButton, nodes);
//   return nodes;
// };

const markupEditorToolStyles = createMarkupEditorToolStyles({
  text: createMarkupEditorToolStyle('text', {
    fontSize: '10%',
  }),
});

const handleEditorLoad = (): any => {
  pinturaEditorRef.value.editor.imageState = cloneDeep(image.value?.state);
  // pinturaEditorRef.value.editor.history.write(image.value?.state);
};

onMounted(async () => {
  const { stickers } = await import('@/data/pintura/stickers/index');
  appStickers.value = stickers;
  editorProps.value = { ...getEditorDefaults(), locale: { ...getEditorDefaults().locale, ...pinturaLocale.value } };
});

watch(
  image,
  (newVal) => {
    pinturaEditorRef.value?.editor?.history?.write(newVal?.state);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_unref(imageForActions) === '' && _unref(imageResult) === '')
    ? (_openBlock(), _createBlock(AddImage, { key: 0 }))
    : (_unref(imageForActions) !== '' && _unref(imageResult) === '')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{ 'service__container--mobile': _unref(isMobile) }, "service__container"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(PinturaEditor), _mergeProps(editorProps.value, {
                src: _unref(imageForActions),
                utils: _unref(utils),
                enableButtonClose: false,
                enableButtonExport: false,
                enableButtonRevert: false,
                previewUpscale: true,
                enableViewTool: true,
                stickerEnableSelectImage: true,
                stickerStickToImage: false,
                stickers: allStickers.value,
                "onPintura:process": _cache[0] || (_cache[0] = ($event: any) => (handleEditorProcess($event))),
                "onPintura:load": handleEditorLoad,
                layoutVerticalToolbarPreference: "bottom",
                markupEditorShapeStyleControls: markupEditorShapeStyleControls.value,
                markupEditorToolbar: _unref(markupEditorToolbar),
                markupEditorToolStyles: _unref(markupEditorToolStyles),
                willRenderShapeControls: willRenderShapeControls,
                ref_key: "pinturaEditorRef",
                ref: pinturaEditorRef
              }), null, 16, ["src", "utils", "stickers", "markupEditorShapeStyleControls", "markupEditorToolbar", "markupEditorToolStyles"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(AiButton, {
                theme: "dark",
                class: "infographics-image-editor__reset-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {
            imageForActions.value = '';
            imageResult.value = '';
          })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('services.reset')), 1)
                ]),
                _: 1
              }),
              _createVNode(AiButton, {
                theme: "gradient-primary",
                class: "infographics-image-editor__save-button",
                onClick: downloadFileHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('image-editor.save-image')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 2))
      : (_unref(imageForActions) !== '' && _unref(imageResult) !== '')
        ? (_openBlock(), _createBlock(ResultImage, { key: 2 }))
        : _createCommentVNode("", true)
}
}

})